import { memo } from 'react'
import { Box } from '@mui/material'
import SubtleShimmer from '../common/SubtleShimmer'

type Props = {
    rows?: number
    /** Mirror the boxed SupportRow layout (icon tile + two lines) instead of flat list rows. */
    boxed?: boolean
}

const WIDTHS = [58, 44, 66, 50, 72, 40]

/** Structure-only placeholder painted by SubtleShimmer, matching the support list rows. */
const SupportListSkeleton = ({ rows = 5, boxed = false }: Props) => (
    <SubtleShimmer loading>
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: boxed ? 0.75 : 0 }}>
            {Array.from({ length: rows }).map((_, i) => (
                <Box
                    key={i}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.25,
                        px: boxed ? 1.25 : 0,
                        py: boxed ? 1 : 1.375
                    }}
                >
                    {boxed ? <Box sx={{ width: 32, height: 32, borderRadius: 1, flexShrink: 0 }} /> : null}
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                        <Box sx={{ width: `${WIDTHS[i % WIDTHS.length]}%`, height: 12, borderRadius: 0.5 }} />
                        {boxed ? <Box sx={{ width: '32%', height: 10, borderRadius: 0.5 }} /> : null}
                    </Box>
                </Box>
            ))}
        </Box>
    </SubtleShimmer>
)

export default memo(SupportListSkeleton)

/** Placeholder for an article body: a title bar and a few paragraphs of lines. */
export const SupportArticleSkeleton = memo(() => (
    <SubtleShimmer loading>
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ width: '70%', height: 16, borderRadius: 0.5, mb: 1 }} />
            {[100, 96, 88, 100, 62, 0, 100, 92, 78].map((w, i) =>
                w === 0 ? <Box key={i} sx={{ height: 6 }} /> : <Box key={i} sx={{ width: `${w}%`, height: 11, borderRadius: 0.5 }} />
            )}
        </Box>
    </SubtleShimmer>
))
